<script>
/**
 * 指示メモ編集モーダル
 */
import { mapActions } from 'vuex'
import DropzoneFile from '../../../../components/DropzoneFile'
import { MANIFEST_ATTACHMENT } from '@/constants/appConst'

export default {
  name: 'OrderInstructionModal',
  components: { DropzoneFile },
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    /**
     * 選択注文ID
     */
    orderId: {
      type: Number,
      default: () => null,
    },
    /**
     * 選択日
     */
    targetDate: {
      type: String,
      default: () => null,
    },
    /**
     * 選択ドライバーID
     */
    targetDriverId: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      forms: {
        id: null,
        driver_instruction: null,
        order_attachments: [],
      },
      files: [],
    }
  },
  computed: {
    MANIFEST_ATTACHMENT() {
      return MANIFEST_ATTACHMENT
    }
  },
  watch: {
    enableDialog (newValue) {
      this.$nextTick(() => this.$refs.observer.reset())
      this.files = []
      Object.assign(this.$data.forms, this.$options.data().forms)
      if (newValue) {
        this.setVariable()
      }
    },
  },
  created() {},
  methods: {
    ...mapActions('DriverScheduleOrderInstruction', {
      fetchOrderInstruction: 'edit',
      updateOrderInstruction: 'update',
    }),
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeCallback')
    },
    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      let $self = this
      this.$refs.observer.validate().then((result) => {
        if(result){
          $self.sendRegistrationInformation()
        }
      })
    },
    sendRegistrationInformation(){
      const params = new FormData()
      params.append('driver_instruction', this.forms.driver_instruction)
      for (const file of this.files) {
        // 新規 or 削除対象のみ
        if (!file.file && !file._destroy) continue

        if (file.id) {
          params.append('order_attachments_attributes[][id]', file.id)
        }
        params.append('order_attachments_attributes[][file]', file.file)
        if (file._destroy) {
          params.append('order_attachments_attributes[][_destroy]', file._destroy)
        }
      }
      this.updateOrderInstruction({ order_id: this.orderId, params: params }).then(() => {
        this.$emit('registerCallback')
      })
    },
    /**
     * 初期値の設定
     */
    setVariable () {
      this.forms = {}
      this.files = []
      this.fetchOrderInstruction({ order_id: this.orderId }).then((content) => {
        this.forms = content
        this.files = content.order_attachments
      });

    }
  }
}
</script>
<template>
  <v-dialog
    :value="enableDialog"
    width="700"
    @click:outside="closeButtonClickEvent"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <v-card>
      <validation-observer
        ref="observer"
        v-slot="{ invalid }"
      >
        <v-toolbar
          color="primary"
          dark
          flat
        >
          <v-toolbar-title>指示メモを編集</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text
          v-if="forms.id"
          style="max-height: 65vh;overflow-y: auto"
        >
          <v-row>
            <v-col>
              <validation-provider
                v-slot="{ errors }"
                name="ドライバー指示メモ"
                rules="max:300"
              >
                <v-textarea
                  v-model="forms.driver_instruction"
                  :error-messages="errors"
                  dense
                  hide-details="auto"
                  label="ドライバー指示メモ"
                  no-resize
                  outlined
                  persistent-placeholder
                  required
                >
                  <template v-slot:label>
                    <span>ドライバー指示メモ</span>
                    <span class="ml-1">
                      ({{ forms.driver_instruction?.length || 0 }} / 300)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-textarea>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- 添付ファイル -->
          <v-row>
            <v-col cols="12">
              <dropzone-file
                :max-size="MANIFEST_ATTACHMENT.MAX_SIZE"
                :accepts="MANIFEST_ATTACHMENT.ACCEPTS"
                :max-file-size="MANIFEST_ATTACHMENT.MAX_FILE_SIZE"
                :alt-file-size-format="MANIFEST_ATTACHMENT.ALT_FILE_SIZE_FORMAT"
                :alt-file-format="MANIFEST_ATTACHMENT.ALT_FILE_FORMAT"
                :immediate-delete="MANIFEST_ATTACHMENT.IMMEDIATE_DELETE"
                :files.sync="files"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            :disabled="!forms.id || invalid"
            color="primary"
            @click="registerButtonClickEvent"
          >
            登録
          </v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>
